import { css, CSSObject, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';
import { DividerVariant } from './Divider';

const getDividerVariantStyles = (theme: Theme, variant?: DividerVariant): CSSObject => {
    switch (variant) {
        case DividerVariant.LARGE:
            return {
                marginBottom: theme.spacing(4),
                marginTop: theme.spacing(4),
            };
        default:
            return {};
    }
};

export const getDividerStyles =
    (variant?: DividerVariant) =>
    (theme: Theme): SerializedStyles =>
        css({
            border: 0,
            borderBottom: `1px solid ${theme.palette.gray.light}`,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            ...getDividerVariantStyles(theme, variant),
        });
